import { linkifyCaption } from '../../../lib/publishing/linkify';

// Renders caption text with its URLs clickable, from the pure linkifyCaption
// (src/lib/publishing/linkify.ts — every detection rule is tested there).
//
// ⚠️ target="_blank" is load-bearing, not a nicety: a click that navigated the
// composer tab away would lose an in-progress composition. rel="noopener
// noreferrer" so the opened page cannot reach back into ours.
//
// Text is rendered as React text nodes, so it stays escaped.
//
// `linkTitle` lets a preview say something true about the link on that
// platform — Instagram does NOT make caption links clickable, so its preview
// links carry a tooltip saying the link is only there to be checked.

export function LinkifiedText({ text, linkTitle }: { text: string; linkTitle?: string }) {
  return (
    <>
      {linkifyCaption(text).map((seg, i) =>
        seg.kind === 'link' ? (
          <a
            key={i}
            href={seg.href}
            target="_blank"
            rel="noopener noreferrer"
            title={linkTitle}
            className="text-blue-700 underline break-all"
          >
            {seg.text}
          </a>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </>
  );
}
